import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

const MY_ICONS = {      
  //'circle': 'far fa-circle',  
}

Vue.use(Vuetify, {  
  iconfont: 'mdi',
  icons: MY_ICONS,
  theme: {
    primary: '#4066aa',
    secondary: '#ec7404',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }  
})